/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetAssetYTMByIdOptions,
  GetAssetYTMByIdStatus200,
  GetAssetYTMByIdStatus400,
  GetAssetYTMByIdStatus404,
} from '../types/GetAssetYTMById'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAssetYTMById } from '../clients/getAssetYTMById'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAssetYTMByIdQueryKey = ({ path }: Omit<GetAssetYTMByIdOptions, 'headers'>) =>
  [{ url: '/v1/assets/:asset_id/ytm', params: path }] as const

type GetAssetYTMByIdQueryKey = ReturnType<typeof getAssetYTMByIdQueryKey>

export function getAssetYTMByIdQueryOptions(
  { path }: GetAssetYTMByIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAssetYTMByIdQueryKey({ path })
  return queryOptions<
    GetAssetYTMByIdStatus200,
    ResponseErrorConfig<GetAssetYTMByIdStatus400 | GetAssetYTMByIdStatus404>,
    GetAssetYTMByIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAssetYTMById({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get annualized yield to maturity for a bond asset
 * {@link /v1/assets/:asset_id/ytm}
 */
export function useGetAssetYTMById<
  TData = GetAssetYTMByIdStatus200,
  TQueryData = GetAssetYTMByIdStatus200,
  TQueryKey extends QueryKey = GetAssetYTMByIdQueryKey,
>(
  { path }: { path: GetAssetYTMByIdOptions['path'] | (() => GetAssetYTMByIdOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAssetYTMByIdStatus200,
        ResponseErrorConfig<GetAssetYTMByIdStatus400 | GetAssetYTMByIdStatus404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getAssetYTMByIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getAssetYTMByIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetAssetYTMByIdStatus400 | GetAssetYTMByIdStatus404>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
